module.exports = __webpack_public_path__ + "static/media/analogySixth.3cdc7a96.svg";